import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Card } from 'primereact/card';
import { Message } from 'primereact/message';
import { Col, Container, Row, } from "reactstrap"
import Logo from '.././assets/images/ats-logo.png';
import { useForm } from "react-hook-form";
import axios from "axios"
import { Link, useNavigate } from "react-router-dom";

import { ProgressSpinner } from 'primereact/progressspinner';

const LoginPage = () => {
    const [companyId, setCompanyId] = useState('');
    const [userId, setUserId] = useState('');

    const [loginError, setLoginError] = useState('');
    const [loginErrormsg, setloginErrormsg] = useState('');
    const navigate = useNavigate();
    useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    if (code) {
        console.log("✅ LinkedIn OAuth code detected:", code);

        // Store once
        localStorage.setItem("linkedin_oauth_code", code);
        localStorage.setItem("linkedin_oauth_url", window.location.href);

        return; // ⛔ stop here, DO NOT redirect
    }
}, []);


    document.title = "ATS"
    const { register, handleSubmit, reset, trigger, formState: { errors }, setValue, getValues } = useForm();
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(false);

    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const [checkingAutoLogin, setCheckingAutoLogin] = useState(true);

    const togglePassword = () => setShowPassword(prev => !prev);
    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                sessionStorage.setItem("user-info", c.substring(name.length, c.length));
                let roles = localStorage.getItem('RolesFromDb');
                sessionStorage.setItem("RolesFromDb", roles);
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
    const code = query.get("code");

    // 🚫 If OAuth code exists, DO NOT redirect yet
    if (code) {
        console.log("OAuth callback detected, skipping auto-redirect");
        // return;
    }

        if (getCookie("userinfoCookie")) {
            navigate("/ats-dashboard");
        } else {
            sessionStorage.removeItem("user-info");
            sessionStorage.removeItem("RolesFromDb");
            localStorage.removeItem("RolesFromDb");
        }

    }, []);
    const onSubmit = async (data) => {
        setLoading(true);
        setDisable(true)
        // if (!loginErrormsg) {
        //     setloginErrormsg("This field is required")
        //     return
        // }
        try {
            // Add a condition here to validate or check `data` before making the API call
            // Example condition
            // const req = {
            //     company_id: data?.companyID,
            //     user_id: data?.userID,
            //     password: data?.password,
            // };

            const req = {
                company_domain: data?.companyID,
                email: data?.userID,
                password: data?.password,
                integration_type: "standalone", // or determine based on companyID or other logic
            };
            const result = await axios.post(`/api/v1/auth/login`, req);

            if (result && result.data) {
                //...added new
                let integrationType = "standalone";
                try {
                    const companies = result?.data?.user_details?.companies_data;
                    if (Array.isArray(companies) && companies.length > 0) {
                        integrationType = companies[0]?.integration_type || "standalone";
                    }
                } catch (e) {
                    console.warn("Couldn't read integration_type from login response, defaulting to standalone", e);
                }
                //..
                const userInfoToSession = {
                    user_details: result?.data?.user_details,
                    token: result.data.token,
                    userEmail: result.data.email,
                    userPhone: result.data.userPhone,
                    firstName: result.data.firstName,
                    integration_type: integrationType, //...added new
                };
                // --- NEW: capture openerTabId and parentOrigin from URL (if parent opened this child) ---
                const urlQuery = new URLSearchParams(window.location.search);
                const openerTabId = urlQuery.get("openerTabId") || null;
                const parentOrigin = urlQuery.get("parentOrigin") ? decodeURIComponent(urlQuery.get("parentOrigin")) : null;
                if (openerTabId) sessionStorage.setItem("openerTabId", openerTabId);
                if (parentOrigin) sessionStorage.setItem("parentOrigin", parentOrigin);

                // --- NEW: capture dynamic addon redirect candidate (if backend provided) ---
                const maybeReturnUrl = result.data.returnUrl || result.data.redirectUrl || null;
                const addonRedirect = parentOrigin || maybeReturnUrl || null;
                if (addonRedirect) sessionStorage.setItem("addonRedirectUrl", addonRedirect);

                // existing persistence
                localStorage.removeItem("menuLoaded");
                sessionStorage.setItem("user-info", JSON.stringify(userInfoToSession));
                // safe cookie encoding
                document.cookie = `userinfoCookie=${encodeURIComponent(JSON.stringify(userInfoToSession))}; path=/`;


            }

            navigate("/ats-dashboard");
            setLoading(false);
            setDisable(false)
        } catch (err) {

            if (err?.response?.data?.error) {
                setLoginError(err?.response?.data?.error);
            }
            setLoading(false);
            setDisable(false)
        }
    };

    //  useEffect(() => {
    //     const query = new URLSearchParams(window.location.search);
    //     const encodedPayload = query.get("payload");

    //     if (!encodedPayload) return; // normal login flow

    //     try {
    //       const payload = JSON.parse(atob(encodedPayload));
    //       console.log("Auto-login payload:", payload);

    //       // Automatically call login API with payload data
    //       (async () => {
    //         setLoading(true);
    //         setDisable(true);
    //         try {
    //           const req = {
    //             company_id: payload.company_id,
    //             user_id: payload.user_id,
    //             password: payload.password || "Test@123", // if included, or handle via token logic
    //           };

    //           const result = await axios.post(`/api/v1/auth/login`, req);

    //           if (result && result.data) {
    //             const userInfoToSession = {
    //               user_details: result.data.user_details,
    //               token: result.data.token,
    //               userEmail: result.data.email,
    //               userPhone: result.data.userPhone,
    //               firstName: result.data.firstName,
    //             };

    //             sessionStorage.setItem("user-info", JSON.stringify(userInfoToSession));
    //             document.cookie = `userinfoCookie=${JSON.stringify(userInfoToSession)}`;

    //             navigate("/ats-dashboard");
    //           }
    //         } catch (error) {
    //           console.error("Auto-login error:", error);
    //           navigate("/login"); // fallback to manual login
    //         } finally {
    //           setLoading(false);
    //           setDisable(false);
    //         }
    //       })();
    //     } catch (e) {
    //       console.error("Invalid payload format");
    //     }
    //   }, [navigate]);


    useEffect(() => {
        (async () => {
            try {
                console.log("CHILD: window.location.href =", window.location.href);
                const query = new URLSearchParams(window.location.search);
                console.info("query",query)
                const encodedPayload = query.get("payload");
                // const code = query.get("code");
                // if (code) {
                //     console.log("OAuth code:", code);

                //     // Option 1: store for other components
                //     localStorage.setItem("linkedin_oauth_code", code);
                //     localStorage.setItem("linkedin_oauth_url", window.location.href);
                //     // OR localStorage.setItem("oauth_code", code);
                // }
                const openerTabIdFromQuery = query.get("openerTabId") || null;
                const parentOriginFromQuery = query.get("parentOrigin") ? decodeURIComponent(query.get("parentOrigin")) : null;


                // console.log("CHILD: encodedPayload =", encodedPayload);

                if (!encodedPayload) {
                    console.warn("CHILD: No payload present in URL.");
                    setCheckingAutoLogin(false);
                    return;
                }

                let decodedString;
                let payload;
                try {
                    decodedString = atob(encodedPayload);
                    payload = JSON.parse(decodedString);
                    console.log("CHILD: decodedPayload =", payload);
                } catch (err) {
                    console.error("CHILD: Error decoding/parsing payload:", err);
                    setCheckingAutoLogin(false);
                    return;
                }
                const reqBody = {
                    company_id: payload.company_id,
                    email: payload.email,
                    password: payload.password,
                };


                // console.log("CHILD: sending login request to backend...", reqBody);

                // Use fetch with credentials: 'include' only if backend sets cookies you need
                const response = await fetch("https://qaatsapi.pranathiss.com/api/v1/auth/login", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(reqBody),
                    // credentials: 'include' // enable only if backend uses cookies and allows cross-site cookies
                });

                // console.log("CHILD: fetch response status =", response.status, response.statusText);

                let respJson = null;
                try {
                    respJson = await response.json();
                    console.log("CHILD: response.json() =", respJson);
                } catch (err) {
                    console.error("CHILD: Error parsing response as JSON:", err);
                }

                // Check network-level success AND presence of token
                if (!response.ok) {
                    console.warn("CHILD: Login request returned non-OK status", response.status);
                    setCheckingAutoLogin(false);
                    return;
                }

                if (!respJson || !respJson.token) {
                    console.warn("CHILD: No token in response:", respJson);
                    setCheckingAutoLogin(false);
                    return;
                }
                //... added new
                let integrationType = "standalone";
                try {
                    const companies = respJson?.user_details?.companies_data;
                    if (Array.isArray(companies) && companies.length > 0) {
                        integrationType = companies[0]?.integration_type || "standalone";
                    } else if (payload?.integration_type) {
                        integrationType = payload.integration_type || "standalone";
                    }
                } catch (e) {
                    console.warn("CHILD: Couldn't determine integration_type, defaulting to standalone", e);
                }

                // --- NEW: persist openerTabId and parentOrigin from query into sessionStorage (so they survive navigation) ---
                if (openerTabIdFromQuery) sessionStorage.setItem("openerTabId", openerTabIdFromQuery);
                if (parentOriginFromQuery) sessionStorage.setItem("parentOrigin", parentOriginFromQuery);
                // Save user info safely (encode cookie value)
                const userInfoToSession = {
                    user_details: respJson.user_details,
                    token: respJson.token,
                    userEmail: respJson.email,
                    userPhone: respJson.userPhone,
                    firstName: respJson.firstName,
                    integration_type: integrationType, //..
                };
                const addonRedirect = parentOriginFromQuery || payload.returnUrl || payload.redirectUrl || null;
                if (addonRedirect) sessionStorage.setItem("addonRedirectUrl", addonRedirect);
                //  console.info(userInfoToSession,urlQuery,parentOriginParam,addonRedirect ,"all info");
                //.. ended new

                sessionStorage.setItem("user-info", JSON.stringify(userInfoToSession));
                // encode cookie value to avoid illegal characters
                document.cookie = `userinfoCookie=${encodeURIComponent(JSON.stringify(userInfoToSession))}; path=/`;

                console.log("CHILD: Auto-login success; navigating to /ats-dashboard");
                navigate("/ats-dashboard");
            } catch (err) {
                console.error("CHILD: Unexpected error in auto-login flow:", err);
                setCheckingAutoLogin(false);
            }
        })();
    }, [navigate]);

    // 👇 Don’t render login form while checking auto-login
    if (checkingAutoLogin) {
        return (
            <div style={{ textAlign: "center", marginTop: "20%" }}>
                <p>Signing you in...</p>
            </div>
        );
    }

    return (
        <div className="flex justify-content-center align-items-center min-h-screen login-page">

            <Card style={{ width: '30rem' }} className='login-card'>

                {/* {loginError && (
                    <Message severity="error" text="Invalid Company ID, User ID, or Password." />
                )} */}
                <div className="flex justify-content-center align-items-center ">
                    <img src={Logo} width="150" height="64" className='mb-2' />
                </div>
                <div className="p-fluid">
                    <form onSubmit={handleSubmit(onSubmit)}>


                        {/* Company ID Field */}
                        <Row className='mb-3'>
                            <Col lg={12}>
                                <h3 className='login-head mb-3'>Log In</h3>
                            </Col>
                            <Col lg={12}>
                                <div className="p-field">
                                    <label htmlFor="companyId">Company Domain<span class="text-danger">*</span></label>
                                    <InputText

                                        placeholder="Enter Company ID"
                                        {...register("companyID", {
                                            required: "This field is required",
                                            // pattern: {
                                            //     value: /^[a-z]+-[0-9]+$/,
                                            //     message: "Company ID ABC-1",
                                            // },
                                            onChange: (event) => event.target.value = event.target.value.toLowerCase()

                                        })}
                                        onKeyUp={() => {
                                            trigger("companyID");
                                            setLoginError("")

                                        }} />
                                    {errors.companyID && (<small className='text-danger font-bold'>{errors.companyID.message}</small>)}
                                </div>
                            </Col>
                        </Row>


                        {/* User ID Field */}
                        <Row className='mb-3'>
                            <Col lg={12}>
                                <div className="p-field">
                                    <label htmlFor="userId">Email <span class="text-danger">*</span></label>
                                    <InputText

                                        // value={userId}
                                        // onChange={(e) => setUserId(e.target.value)}
                                        placeholder="Enter User ID"
                                        {...register("userID", {
                                            required: "This field is required",
                                            // pattern: {
                                            //     value: /^[A-Za-z][A-Za-z-\s]+$/,
                                            //     message: "Please enter a valid User ID",
                                            // },
                                            // onChange: (event) => event.target.value = event.target.value.toLowerCase()

                                        })}
                                        onKeyUp={() => {
                                            trigger("userID");
                                            setLoginError("")

                                        }} />
                                    {errors.userID && (<small className='text-danger font-bold'>{errors.userID.message}</small>)}
                                </div>
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col lg={12}>
                                {/* Password Field */}
                                <div className="p-field">
                                    <label htmlFor="password">Password<span class="text-danger">*</span></label>
                                    <div className="p-inputgroup">
                                        <InputText
                                            id="password"
                                            type={showPassword ? ' text' : 'password'}
                                            // value={password}
                                            // onChange={(e) =>{ setPassword(e.target.value); setLoginError("")} }
                                            placeholder="Enter your password"
                                            {...register("password", {
                                                required: "This field is required",
                                            })}
                                            onKeyUp={() => {
                                                trigger("password");
                                                setLoginError("")

                                            }}
                                        />
                                        <Button
                                            icon={showPassword ? 'pi pi-eye ' : 'pi pi-eye-slash'}
                                            onClick={togglePassword}
                                            className="p-button-outlined"
                                            type="button"
                                        />
                                    </div>
                                    {errors.password && (<small className='text-danger font-bold'>{errors.password.message}</small>)}
                                    {/* <Password
                                        id="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        toggleMask={true}       // shows the eye icon
                                        feedback={false}
                                        placeholder="Enter your password"
                                        // {...register("password", {
                                        //     required: "This field is required",
                                        //     pattern: {
                                        //         value: /^\S*$/,
                                        //         message: "Please Enter Valid Password",
                                        //     },
                                        //     onChange: (event) => event.target.value = event.target.value.toLowerCase()

                                        // })}
                                        onKeyUp={() => {
                                            trigger("password");
                                            setLoginError()
                                        }}
                                    /> */}
                                    {/* {errors.password && (<small className='text-danger font-bold'>{errors.password.message}</small>)} */}
                                </div>
                            </Col>
                        </Row>
                        {/* <small className='text-danger'>{loginErrormsg}</small> */}
                        <small className='text-danger'>{loginError}</small>
                        {/* Forgot Password Link */}
                        <div className="p-field d-flex justify-content-end mb-2">
                            {/* <Link to="/forgot-password" className="p-link">Forgot Password?</Link> */}
                        </div>

                        <Row>
                            {loading && (
                                <div className="flex justify-content-center align-items-center mt-3">
                                    <ProgressSpinner />
                                </div>
                            )}
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <div className='d-flex justify-content-center'>
                                    <Button

                                        className="btn btn-primary btn-main mb-4"
                                        type="submit"
                                        disabled={loading || disable}
                                    >
                                        Login
                                    </Button>


                                </div>

                            </Col>
                        </Row>



                    </form>
                    <Row>
                        <Col>
                            <div className='d-flex justify-content-center'>
                                <p className='me-1'>New Company?</p>
                                <Link to="/register" className="p-link">Register</Link>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Card>
        </div>
    );
};

export default LoginPage;
